/* Structural layout only — colors come from Astryx design tokens (resolved
   inside a <Theme> scope), and are owned by the cards this row holds. */

/* The feature panel takes four fifths of the row; the cards beside it stack in
   the remaining fifth, together matching its height. Narrower pages give the
   feature its own row with the cards side by side beneath; with no cards to
   show, the feature spans the row alone. */
.row {
  display: grid;
  grid-template-columns: 4fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: var(--spacing-6);
}

.row > :first-child {
  grid-row: 1 / -1;
}

.row > :only-child {
  grid-column: 1 / -1;
}

@media (max-width: 1100px) {
  .row {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
  }

  .row > :first-child {
    grid-row: auto;
    grid-column: 1 / -1;
  }
}
